import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { Report } from '@classes/report/report';
import { ReportTypeCode } from '@enums/report-type-code.enum';
import { ReportCustom } from '@classes/report/report-custom';
import { ReportService } from '@services/report.service';
import { UiService } from '@services/ui.service';
import { ReportMode } from '@enums/report-mode.enum';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
    selector: 'app-report-wrapper',
    templateUrl: './report-wrapper.component.html',
    styleUrls: ['./report-wrapper.component.scss']
})
export class ReportWrapperComponent implements OnInit, OnDestroy {
    @Input() selMode: ReportMode;

    @ViewChild('tabs') tabs: MatTabGroup;

    private reportSub: Subscription;
    private customReportsSub: Subscription;
    private printModeSub: Subscription;
    private loadingSub: Subscription;

    report: Report;
    isPrintMode: boolean;
    customReports: ReportCustom[];
    reportType = ReportTypeCode;
    reportMode = ReportMode;

    constructor(
        private reportSrv: ReportService,
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    onExportPpt(): void {
        this.reportSrv.printModeChanged.next(true);
        this.customReports = this.reportSrv.customReportsSubject.value;

        setTimeout(() => {
            this.reportSrv.exportReportImages();
        }, 1000);
    }

    onAddCustom(): void {
        this.reportSrv.addCustomReport();
        setTimeout(() => this.tabs.selectedIndex = this.tabs._tabs.length - 2, 100);
    }

    onRemoveCustom(index: number) {
        const isLast = index == this.customReports.length - 1;
        this.reportSrv.removeCustomReport(index);

        if (isLast)
            setTimeout(() => this.tabs.selectedIndex -= 1, 100);
    }

    private initSubscriptions(): void {
        this.reportSub = this.reportSrv.selectedReportChanged
        .subscribe(report => {
            this.report = report;
        });

        this.customReportsSub = this.reportSrv.customReportsSubject
        .subscribe(reports => {
            this.customReports = [ ...reports ];
        });

        this.printModeSub = this.reportSrv.printModeChanged
        .subscribe(printMode => {
            this.isPrintMode = printMode;
        });

        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            if(!loadingState) {
                this.isPrintMode = false;
            }
        });
    }

    ngOnDestroy() {
        if(this.printModeSub) {
            this.printModeSub.unsubscribe();
        }
        if(this.customReportsSub) {
            this.customReportsSub.unsubscribe();
        }
        if(this.reportSub) {
            this.reportSub.unsubscribe();
        }
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
